import React from "react";
import CustomHelmet from "../components/CustomHelmet";
import MainLayout from "../components/MainLayout";
import styled from "styled-components";
import { Container } from "../styles/container";
const Section = styled.section`
  background: rgb(132, 50, 11);
  background: linear-gradient(
    90deg,
    rgba(132, 50, 11, 1) 0%,
    rgba(203, 134, 11, 1) 80%
  );
  // padding: 20px 0px;
`;

const Content = styled.div`
  align-items: center;
  column-gap: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 767px) {
    grid-template-columns: 1fr;
    row-gap: 40px;
  }
`;

const Left = styled.div`
  padding: 30px 0px;
  @media (max-width: 767px) {
    order: 1;
  }
  > h1 {
    font-family: var(--casanova);
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 0.2rem;
    line-height: 1.4;
    margin-bottom: 15px;
    text-transform: uppercase;
    text-align: left;

    @media (max-width: 1399px) {
      font-size: 40px;
    }
    @media (max-width: 1199px) {
      font-size: 32px;
    }
    @media (max-width: 991px) {
      font-size: 26px;
    }
    @media (max-width: 767px) {
      text-align: left;
    }
    @media (max-width: 400px) {
      font-size: 20px;
    }
  }
  > p {
    font-size: 16px;
    font-family: var(--montserrat);
    line-height: 1.5;
    margin-bottom: 5px;
    text-align: left;

    @media (max-width: 567px) {
      font-size: 12px;
    }
  }
`;

const Right = styled.div`
  height: 100%;
  position: relative;
  img {
    width: 70%;
    // height: 100%;
    // object-fit: cover;
    display: block;
    // position: absolute;
    // bottom: 0;
    // right: 0;
    margin-left: auto;
    @media (max-width: 767px) {
      position: unset;
    margin: auto;

    }
  }
  @media (max-width: 767px) {
    order: 2;
  }
`;

const TextContent = styled.div`
  margin: 40px 0px;
  .campus {
    margin: 40px auto;
  }
  > h4 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.4;
    color: var(--dark);
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  > p {
    font-size: 14px;
    color: var(--dark);
    line-height: 1.5;
    margin-bottom: 10px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  > button {
    background: linear-gradient(90deg, #f4b60b, #b6510c);
    color: var(--white);
    column-gap: 6px;
    font-size: 16px;
    border: 1px solid #b6510c;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 0px;
    height: 34px;
    width: 200px;
    transition: 0.4s;
    margin: 0 auto;

    &:hover {
      background: var(--white);
      color: var(--choco);
    }
  }
  > ul {
    margin-bottom: 12px;
    list-style: none;
    li {
      padding-left: 15px;
      font-size: 14px;
      line-height: 1.5;
      color: var(--dark);
      @media (max-width: 768px) {
        font-size: 12px;
      }
      > strong {
        width: max-content;
        white-space: nowrap;
        margin-right: 4px;
      }
    }
  }
`;

const EducationTool = () => {
  return (
    <>
      <CustomHelmet
        title="Learn Faster with Interactive Simulations | Arcaptor"
        description="Experience hands-on learning like never before with Experiment Adda! Accelerate your understanding through engaging, interactive simulations."
      />
      <MainLayout>
        <Section>
          <Container>
            <Content>
              <Left>
                <h1>Making learning more collaborative and efficient</h1>
                <p>#TeacherAssistant.in</p>
                <p>#Group-Study.in</p>
              </Left>
              <Right>
                <img
                  src="./images/educationToolHero.png"
                  alt="educationToolHero"
                />
              </Right>
            </Content>
          </Container>
        </Section>
        <Container>
          <TextContent>
            <h2 className="main_heading">
              Empowering collaboration and teaching efficiency through smart
              tools that make learning seamless and connected.
            </h2>
            <p>
              At <b>Arcaptor</b>, we believe that true learning happens when
              both students and educators are empowered with the right tools.
              Traditional systems often create gaps—between teaching and
              understanding, effort and outcomes, and collaboration and
              consistency. Our mission is to bridge these gaps by building smart
              education tools that enhance productivity, simplify workflows, and
              create a more connected learning experience.
            </p>
            <br />
            <p>
              We are developing a growing suite of Education Tools designed to
              make learning more collaborative, efficient, and outcome-driven.
              These tools are not just add-ons—they are integral to how modern
              education should function. By combining technology with practical
              learning needs, we ensure that students can focus on learning
              while teachers can focus on guiding.
            </p>
            <br />
            <h4>Teacher’s Assistant – Empowering Educators</h4>
            <br />
            <p>
              Teachers play a critical role in shaping outcomes, but much of
              their time is often consumed by repetitive tasks like checking
              assignments, tracking performance, and managing progress.
              Teacher’s Assistant is designed to solve this. It acts as a smart
              support system that helps teachers automate evaluation, analyze
              student performance, and gain actionable insights. With reduced
              manual effort, teachers can focus more on personalized guidance,
              improving both teaching quality and student results. It’s not just
              a tool—it’s a productivity multiplier for educators.
            </p>
            <br />
            <button
              onClick={() =>
                window.open(
                  "https://teacherassistant.in/",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              View Teacher’s Assistant
            </button>
            <br />
            <br />

            <h4>Group Study – Learning Together, Growing Faster</h4>

            <br />
            <p>
              Learning is more effective when it’s collaborative. Group Study is
              built to bring students together in a structured and focused
              environment where they can learn, discuss, and grow as a team. It
              enables peer-to-peer interaction, accountability, and real-time
              collaboration—key elements for better understanding and retention.
              Especially for competitive exams and personality-based assessments
              like SSB, Group Study helps students develop communication skills,
              teamwork, and confidence, making preparation more engaging and
              effective.
            </p>
            <br />
            <button
              onClick={() =>
                window.open(
                  "https://group-study.in/",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
            >
              View Group-Study
            </button>
            <br />
            <br />
            <p>
              At Arcaptor, we are continuously innovating and expanding our
              ecosystem of tools to support learners at every stage. Our vision
              is simple—to create a future where technology empowers both
              teaching and learning, making education smarter, faster, and more
              impactful.
            </p>
          </TextContent>
        </Container>
      </MainLayout>
    </>
  );
};

export default EducationTool;
